// extracted by mini-css-extract-plugin
export default {"container":"Accounts_container__ageBo","tableContainer":"Accounts_tableContainer__l39qS"};